<div class="pass-fail-container" [ngClass]="isSuccess ? 'pass' : 'fail'">
  <div class="pass-fail-content"><ng-content #content></ng-content></div>
</div>
